export default __webpack_public_path__ + "static/media/landing-gift.45c5600a.png";